import { API } from "../../lib/api";

const B = (from, to, code, fg = "#fff") => ({ from, to, code, fg });

export const BRANDS = {
  mlbb: B("#2563eb", "#0b1f5c", "MLBB"), pubg: B("#f2a900", "#2b2b2b", "PUBG"), ff: B("#ff7a00", "#b91c1c", "FF"),
  hok: B("#d4a64a", "#4a1d0c", "HOK"), genshin: B("#5aa9e6", "#26365f", "GI"), hsr: B("#7c6cf0", "#1c1a4a", "HSR"),
  codm: B("#3f3f46", "#0a0a0a", "CODM", "#f5a524"), roblox: B("#e2231a", "#111111", "RBX"),
  steam: B("#2a475e", "#171a21", "STEAM"), googleplay: B("#34a853", "#0b6b45", "PLAY"), apple: B("#6b7280", "#111111", "APPLE"),
  razergold: B("#44d62c", "#0a0a0a", "RAZER", "#0a0a0a"), garena: B("#ff5a36", "#b3261e", "SHELLS"), hotlink: B("#ff2d2d", "#ff8a00", "HOTLINK"),
  celcomdigi: B("#0057b8", "#00a3e0", "CD"), umobile: B("#ff8a00", "#3a3a3a", "U"),
};

const GROUP_LABEL = { games: "Game", vouchers: "Gift Card", reload: "Reload" };
const LOGOS = new Set(["apple", "celcomdigi", "ff", "garena", "genshin", "googleplay", "hsr", "hok", "hotlink", "mlbb", "pubg", "razergold", "roblox", "steam"]);
const logo = (slug) => (LOGOS.has(slug) ? `/images/topup/${slug}.png` : `${API}/topup-logo/${slug}`);
const hide = (e) => { e.currentTarget.style.display = "none"; e.currentTarget.nextSibling && (e.currentTarget.nextSibling.style.display = "flex"); };

const brand = (slug, name) => BRANDS[slug] || B("#ee4d2d", "#ff7337", name.split(/\s+/).map((w) => w[0]).join("").slice(0, 3).toUpperCase());

export const TopupIcon = ({ slug, name, className = "h-11 w-11" }) => {
  const b = brand(slug, name);
  const src = logo(slug);
  return (
    <>
      <img src={src} alt={name} onError={hide} className={`shrink-0 rounded-lg border border-[#eee] bg-white object-contain p-1 ${className}`} />
      <span className={`shrink-0 items-center justify-center rounded-lg text-[10px] font-black tracking-tight shadow-inner ${className}`}
        style={{ display: "none", background: `linear-gradient(135deg, ${b.from}, ${b.to})`, color: b.fg }} aria-hidden="true">{b.code}</span>
    </>
  );
};

export const TopupTile = ({ g }) => {
  const b = brand(g.slug, g.name);
  return (
    <div className="group relative flex h-full flex-col overflow-hidden rounded-xl bg-white shadow-[0_1px_3px_rgba(0,0,0,.08)] transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-[0_8px_20px_rgba(238,77,45,.18)]">
      <div className="relative flex h-24 items-center justify-center" style={{ background: `linear-gradient(135deg, ${b.from}, ${b.to})` }}>
        <span className="absolute -right-4 -top-6 h-20 w-20 rounded-full bg-white/10" />
        <span className="absolute -bottom-8 -left-4 h-16 w-16 rounded-full bg-white/10" />
        <img src={logo(g.slug)} alt={`${g.name} logo`} onError={hide} className="relative h-14 w-14 rounded-xl bg-white object-contain p-1.5 shadow-md transition-transform duration-200 group-hover:scale-110" data-testid={`topup-logo-${g.slug}`} />
        <span className="relative text-xl font-black tracking-tight drop-shadow-sm" style={{ display: "none", color: b.fg }}>{b.code}</span>
      </div>
      <div className="flex flex-1 flex-col justify-between gap-1 p-3">
        <p className="line-clamp-2 text-sm font-semibold leading-snug text-[#222]">{g.name}</p>
        <span className="w-fit rounded-full bg-[#fff1ee] px-2 py-0.5 text-[10px] font-bold uppercase text-[#ee4d2d]">{GROUP_LABEL[g.group] || "Digital"}</span>
      </div>
    </div>
  );
};
